import componentHelper from '../../modules/component_helper.js';

angular.module('vastdesk').
  component('appNameListTargeting',  {
    bindings: {
      formName: '@',
      formId: '@',
      allowList: '@',
      selectedOptions: '<',
      sharing: '<',
      overrideCheckboxEnabled: '<',
      overrideCheckboxValue: '<',
      overrideCheckboxLabel: '@'
    },
    template: require("../templates/appNameListTargeting.html"),
    controllerAs: '$appNameListTargetingCtrl',
    controller: ['$scope', '$timeout', function($scope, $timeout) {
      var self = this;

      this.allowlistButtonOptions = componentHelper.allowlistOptions();
      this.shareButtonOptions = componentHelper.attributeEnabledMappings();
      this.showOverrideCheckbox = false;
      this.selectElement = null;

      this.shareButtonTooltip = function(val) {
        if (val) {
          return 'Allow DC partner to view app names on app name list';
        }
      };

      this.hasSelectedLists = function() {
        return self.selectedOptions && self.selectedOptions.length > 0;
      };
      
      this.updateOverrideCheckboxVisibility = function() {
        if (!self.selectElement) { return; }

        var hasSelections = Array.from(self.selectElement.options || []).some(option => option.selected && option.value);

        if (hasSelections !== self.showOverrideCheckbox) {
          $timeout(function() {
            self.showOverrideCheckbox = hasSelections;
            if (!hasSelections) {
              self.overrideCheckboxValue = false;
            }
          });
        }
      };

      this.$onInit = function() {
        self.showOverrideCheckbox = self.hasSelectedLists();

        // Ensure overrideCheckboxValue is boolean
        self.overrideCheckboxValue = (self.overrideCheckboxValue === true || self.overrideCheckboxValue === 'true');

        // Setup event listeners and initial state
        $timeout(function() {
          self.selectElement = document.getElementById(self.formId + '_app_name_list_ids');
          if (self.selectElement) {
            $(self.selectElement).on('change', self.updateOverrideCheckboxVisibility);
            self.updateOverrideCheckboxVisibility();
          }
        });

        $scope.$on('$destroy', function() {
          if (self.selectElement) {
            $(self.selectElement).off('change', self.updateOverrideCheckboxVisibility);
          }
        });
      };
    }]
});
